import axios from 'axios'
import { RECENTLY_VIEWED_PRODUCTS } from '~/js/constants/local-storage-keys'
import Product from '~/js/models/product'
import FavoriteProduct from '~/js/models/FavoriteProduct'
import { Article } from '~/js/models/article'

export const getItemsFromIds = async (ids, type = 'product') => {
  // /search で返ってくる件数が最大10なので分割する
  const RESULT_MAX = 10
  const idsSplited = []
  const length = Math.ceil(ids.length / RESULT_MAX)
  for (let i = 0; i < length; i++) {
    idsSplited.push(ids.slice(i * RESULT_MAX, (i + 1) * RESULT_MAX))
  }

  const resultTmp = {}
  await Promise.all(
    idsSplited.map(async (ids) => {
      const q = ids.map((id) => `id:${id}`).join(' OR ')
      const params = {
        q,
        type,
        view: `${type}-json`,
      }
      if (type == 'product') params['options[unavailable_products]'] = 'show'
      return await axios.get('/search', { params }).then((result) => {
        const items = result.data
        items.forEach((item) => {
          resultTmp[item.id] = item
        })
      })
    })
  )
  // 受け取ったidの順番通りに返す
  return ids
    .filter((id) => resultTmp[id])
    .map((id) => {
      if (type == 'article') return new Article(resultTmp[id])
      return new Product(resultTmp[id])
    })
}

export const getProductFromHandle = async (handle) => {
  return await axios
    .get(`/products/${handle}.js`)
    .then((result) => {
      return result.data
    })
    .catch((e) => {
      console.error(e)
    })
}

export const getRecentProductIds = () => {
  const localStorageProductsString = localStorage.getItem(
    RECENTLY_VIEWED_PRODUCTS
  )
  if (!localStorageProductsString) return []
  try {
    const localStorageProducts = JSON.parse(localStorageProductsString)
    return localStorageProducts
      .filter((product) => !product.tags.includes('noindex'))
      .map((product) => product.id)
  } catch (e) {
    console.error(e)
    return []
  }
}

export const getProductsWithHashtag = async (tag) => {
  return await axios
    .get('/search', {
      params: {
        q: `tag:${tag}`,
        type: 'product',
        view: 'product-json',
        limit: 4,
        'options[unavailable_products]': 'show',
      },
    })
    .then((result) => {
      const products = result.data
      return products.map((product) => new Product(product))
    })
}

/**
 * 指定されたハンドルの配列から商品情報を取得する
 * @param {string[]} handles 商品ハンドルの配列
 * @returns {Promise<Product[]>} 商品情報の配列
 */
export const getProductsByHandles = async (handles) => {
  if (!handles.length) return []

  const { baseUrlFrontNamed } = document.getElementById('js-data').dataset

  try {
    const { data } = await axios.post(
      `${baseUrlFrontNamed}/products/published/by-handles`,
      {
        handles,
      }
    )

    const products = data?.products || []
    const productsByHandle = new Map(
      products.map((product) => [product.handle, product])
    )

    const items = []
    for (const handle of handles) {
      const product = productsByHandle.get(handle)
      if (!product) continue

      const variant = product.variants?.[0] ?? null
      items.push(new FavoriteProduct(product, variant))
    }
    return items
  } catch (error) {
    console.error('Failed to load favorite products:', error)
    throw error
  }
}
